import React from "react";
import { Helmet } from "react-helmet";

const SeoMeta = ({
  lang = "en",
  title,
  description,
  keywords,
  robots,
  imageUrl,
}) => {
  const fullImageUrl = imageUrl?.startsWith("http")
    ? imageUrl
    : imageUrl
    ? `${process.env.REACT_APP_STRAPI_URL}${imageUrl}`
    : null;

  return (
    <Helmet>
      {/* HTML language attribute */}
      <html lang={lang} />

      {/* Basic Meta Tags */}
      {<title>{title ? `${title} - Alberto Lussana` : 'Alberto Lussana'}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {robots && <meta name="robots" content={robots} />}

      {/* Open Graph Tags */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {fullImageUrl && <meta property="og:image" content={fullImageUrl} />}
      <meta property="og:type" content="website" />

      {/* Twitter Tags */}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {fullImageUrl && <meta name="twitter:image" content={fullImageUrl} />}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default SeoMeta;
